import { appSettings } from "core/config";
import { CountryPaymentVendors } from "core/constants";
import UrlUtils from "core/lib/url-utils";
import { User } from "core/models";

type MahPaymentRequestOptions = {
    currency: string;
    smartCardNumber: string;
    firstName: string;
    lastName: string;
    amount: number;
    languageCode: string;
    accountNumber: number;
    productNamesPrices: string;
    dueDate: any;
}

const PaymentDefaults = {
    paymentType: "DStvPayment",
    vendorType: "DPP",
    languageCode: "EN"
};

const getPaymentVendor = (countryCode = "") => {
    const code = countryCode as keyof typeof CountryPaymentVendors;
    const vendor = CountryPaymentVendors[code];
    return vendor ?? PaymentDefaults.vendorType;
}

export class MahPaymentRequest {
    accountBalance = "0";
    accountNumber = 0;
    amount = 0;
    amountToPay = "";
    backUrl = "";
    bypassPaymentSuite = true;
    currency = "";
    customerNumber = 0;
    dueDate = null
    failureReturnUrl = "";
    firstName = "";
    languageCode = PaymentDefaults.languageCode;
    name = "";
    paymentType = PaymentDefaults.paymentType;
    productNamesPrices = "";
    productUserKey = "";
    smartCardNumber = "";
    successReturnUrl = "";
    vendorType = PaymentDefaults.vendorType;

    constructor(props: MahPaymentRequestOptions) {
        const {
            currency,
            smartCardNumber,
            firstName,
            lastName,
            amount,
            languageCode,
            accountNumber,
            productNamesPrices,
            dueDate
        } = props;

        const { result, success, failed } = appSettings.urls.mahPayment;

        const name = `${firstName} ${lastName}`.trim();

        const vendor = getPaymentVendor(User.instance?.countryCode)

        this.accountNumber = accountNumber;
        this.amount = amount;
        this.amountToPay = amount.toString();
        this.backUrl = result;
        this.currency = currency;
        this.dueDate = dueDate;
        this.failureReturnUrl = failed;
        this.firstName = firstName;
        this.languageCode = languageCode;
        this.name = name || "unknown";
        this.productNamesPrices = productNamesPrices;
        this.smartCardNumber = smartCardNumber;
        this.successReturnUrl = success;
        this.vendorType = vendor ?? this.vendorType;
    }
}
